import {
    Component,
    OnInit,
    ViewChild,
    Input,
    Output,
    EventEmitter,
    HostListener,
    OnChanges,
    SimpleChanges,
    OnDestroy,
} from "@angular/core"
import { Router, ActivatedRoute } from "@angular/router"
import Player from "@vimeo/player/dist/player.js"

declare var $: any

@Component({
    selector: "app-video",
    templateUrl: "./video.component.html",
    styleUrls: ["./video.component.scss"],
    standalone: false
})
export class VideoComponent implements OnInit, OnChanges, OnDestroy {
    @Input("items") items

    @Input("startAt") startAt: number = 0
    @Input("skipToEnd") skipToEnd: boolean = false
    @Input("showVote") showVote: boolean = false
    @Input("question") question: string = ""

    @Input("previewing") previewing: boolean = false

    @ViewChild("video", { static: false }) video: any
    @Output() endSection = new EventEmitter<{}>()
    @Output() finishedMedia = new EventEmitter<{}>()
    @Output() playedMedia = new EventEmitter<{}>()
    @Output() startedMedia = new EventEmitter<{}>()

    @Output() emitRating = new EventEmitter<{}>()

    currentTime: number = 0

    duration: number = 1
    progressValue: number = 0
    underPlay: boolean = false
    votedValue: number = 0
    mediaType: string = "video"
    currentObject: any
    videoVimeoId: any
    autoplay: boolean = true
    player: any = null
    sentPlayed: boolean = false
    timeoutId: any = null
    loadingNewVideo: boolean = false
    lastUpdated: number = 0
    updateInterval: number = 1000
    showShowPlay: boolean = false
    isPlaying: boolean = false

    currentlyPlaying: number = 0

    qpListener = null

    constructor(private router: Router, private route: ActivatedRoute) {}

    ngOnInit() {
        this.qpListener = this.route.queryParams.subscribe((queryParams) => {
            if (queryParams.autoplay) {
                this.autoplay = true || queryParams.autoplay === "true"
            }

            this.videobgEnlarge()
        })
    }

    ngOnDestroy(): void {
      this.qpListener.unsubscribe()
    }

    @HostListener("window:resize", ["$event"])
    onResize(event) {
        var timeoutId
        clearTimeout(timeoutId)
        timeoutId = setTimeout(this.videobgEnlarge, 10)
    }

    ngOnChanges(changes: SimpleChanges): void {
      console.log('updated start at', this.startAt)
      this.loadNewGame()
    }


    videobgEnlarge() {
        var $videoBgAspect = $(".videobg-aspect")
        var $videoBgWidth = $(".videobg-width")
        var videoAspect =
            $videoBgAspect.outerHeight() / $videoBgAspect.outerWidth()
        var windowAspect = $(window).height() / $(window).width()
        if (windowAspect > videoAspect) {
            $videoBgWidth.width((windowAspect / videoAspect) * 100 + "%")
        } else {
            $videoBgWidth.width(100 + "%")
        }
    }

    //From video playProgress and loaded (called by vimeo player)
    onMediaTimeUpdate(data: { seconds: any; percent: any; duration: any }) {
        this.currentTime = data.seconds
        this.duration = data.duration
        this.progressValue = data.percent * 100
        if (data.percent > 0) {
            $("body").removeClass("loading")
        } else if (data.percent >= 1) {
            this.currentTime = this.duration
            this.progressValue = 100
        }
    }

    //when video has "finished" (called by vimeo player)
    onMediaEnd() {
        this.currentTime = this.duration
        this.progressValue = 100
        this.showVote = true
        this.finishedMedia.emit({})
    }

    //called by play button
    onPlay() {
        let obj = this
        this.isPlaying = true
        if (this.skipToEnd) {
            this.player.setCurrentTime(this.duration - 2)
        }
        this.player.getPaused().then(function (paused) {
            if (paused && obj.progressValue !== 100) {
                $("body").addClass("loading")
                obj.player.play()
            }
        })
    }

    onPlayProgress() {
        $("body").removeClass("loading")
        if (this.isPlaying) {
            this.underPlay = true
        }
        if (!this.sentPlayed) {
            this.sentPlayed = true
            this.startedMedia.emit({
                sourceId: this.currentObject.id,
            })
        }
    }

    //called by submit vote and (checkIfPlaying, which attempts to show play button if video has not successfully started)
    onPause(paused: { underPlay: boolean; loadNew: boolean }) {
        this.isPlaying = false
        this.underPlay = paused.underPlay
        let obj = this
        this.player
            .pause()
            .then(function () {
                // the player was paused
                if (paused.loadNew === true) {
                    obj.loadNewGame()
                }
            })
            .catch(function (error) {
                // an error occurred
                console.log(error)
                console.log("an error occurred under pause()")
                if (paused.loadNew === true) {
                    obj.loadNewGame()
                }
            })
    }

    //when you click to select a vote
    onVote(makeVote: {
        voted: boolean
        votedPreValue: number
        votedValue: number
    }) {
        this.showVote = makeVote.voted
        this.votedValue = makeVote.votedValue
    }

    //when you click "next/finish"
    onSubmitVote(vote) {
        this.finishedMedia.emit({})

        this.emitRating.emit({
            isVideo: true,
            value: vote.votedValue,
            ...this.currentObject,
        })

        this.onPause({ underPlay: false, loadNew: false })
    }

    //timeout called to attempt to play video if video has not played
    checkIfPlaying() {
        $("body").removeClass("loading")
        this.showShowPlay = true
    }

    private loadNewGame() {
        this.showVote = this.previewing
        if (this.startAt < this.items.length) {

          this.currentObject = this.items[this.startAt]

            this.videoVimeoId = this.currentObject.video
            let obj = this
            if (this.autoplay) {
                $("body").addClass("loading")
                this.isPlaying = true
                this.showShowPlay = false
            } else {
                this.showShowPlay = true
            }
            if (this.player == null) {
                $(".videobg-hide-controls").html(
                    '<iframe id="vimeo_' +
                        obj.videoVimeoId +
                        '" src="https://player.vimeo.com/video/' +
                        obj.videoVimeoId +
                        `?api=1&background=1&mute=0&loop=0&autoplay=${
                            this.autoplay ? 1 : 0
                        }" style="visibility:hidden" onload="this.style.visibility = \'visible\'" width="100%" height="100%" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen allow="autoplay"></iframe>`
                )
                this.sentPlayed = false
                this.player = new Player($("#vimeo_" + obj.videoVimeoId))
            } else {
                this.loadingNewVideo = true
                this.lastUpdated = undefined
                this.player
                    .loadVideo(obj.videoVimeoId)
                    .then(function () {
                        obj.sentPlayed = false
                    })
                    .catch(function (error) {
                        console.log("some other error occurred")
                        console.log(error)
                    })
            }
            this.player.on("timeupdate", function (data) {
                if (!obj.loadingNewVideo) {
                    obj.onPlayProgress()
                    if (
                        !obj.lastUpdated ||
                        obj.lastUpdated + obj.updateInterval < Date.now()
                    ) {
                        obj.lastUpdated = Date.now()
                        obj.onMediaTimeUpdate(data)
                    }
                }
            })
            this.player.on("loaded", function (data) {
                obj.player.setVolume(1)
                clearTimeout(this.timeoutId)
                this.timeoutId = setTimeout(() => {
                    obj.checkIfPlaying()
                }, 250)
                obj.player
                    .getDuration()
                    .then(function (duration) {
                        obj.loadingNewVideo = false
                        obj.onMediaTimeUpdate({
                            seconds: 0,
                            percent: 0,
                            duration: duration,
                        })
                    })
                    .catch(function (error) {
                        // an error occurred
                    })
            })
            this.player.on("ended", function (data) {
                obj.currentTime = obj.duration
                obj.onMediaEnd()
            })
            //this.videobgEnlarge()
        } else if (
            this.startAt == this.items.length &&
            this.currentObject !== undefined
        ) {
            //section has ended. Emit event
            this.player
                .destroy()
                .then(function () {
                    // the player was destroyed
                    console.log('player destroyed.')
                })
                .catch(function (error) {
                    // an error occurred
                    console.log(error)
                    console.log("some other error occurred under destroy()")
                })
            this.endSection.emit({})
            this.currentlyPlaying = 0
        }
    }
}
